module.exports = "pegasus_template/assets/themecapture1/simple/102.png";